(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fmtMoney(cents){ return '$' + (cents / 100).toFixed(2); }
  function fmtCents(cents){ return Math.round(cents) + '¢'; }
  function perUnitCents(priceCents, qty){ return priceCents / (qty * 100); }

  var bundleRows = document.querySelectorAll('.bundle-row');
  var addToCartBtn = document.getElementById('addToCartBtn');
  var finalCtaBtn = document.getElementById('finalCtaBtn');

  function selectedRow(){
    return document.querySelector('.bundle-row[aria-checked="true"]') || bundleRows[0];
  }

  function renderBundleUI(){
    if(!bundleRows.length) return;
    var baseRow = bundleRows[0];
    var baseCents = fmtCents(perUnitCents(Number(baseRow.dataset.price), Number(baseRow.dataset.qty)));
    document.querySelectorAll('.dyn-cents-base').forEach(function(el){ el.textContent = baseCents; });

    bundleRows.forEach(function(row){
      var priceCents = Number(row.dataset.price);
      var qty = Number(row.dataset.qty);
      var perUnitEl = row.querySelector('.bundle-row-perunit');
      if(perUnitEl) perUnitEl.textContent = '~' + fmtMoney(perUnitCents(priceCents, qty)) + '/wrap';
    });

    var sel = selectedRow();
    var selPriceCents = Number(sel.dataset.price);
    var selQty = Number(sel.dataset.qty);
    var selCompareCents = Number(sel.dataset.comparePrice || 0);
    var selCentsStr = '~' + fmtCents(perUnitCents(selPriceCents, selQty));
    document.querySelectorAll('.dyn-cents-selected').forEach(function(el){ el.textContent = selCentsStr; });

    var priceEl = document.getElementById('pdpPrice');
    var originalEl = document.getElementById('pdpPriceOriginal');
    if(priceEl) priceEl.textContent = fmtMoney(selPriceCents);
    if(originalEl){
      if(selCompareCents > selPriceCents){
        originalEl.textContent = fmtMoney(selCompareCents);
        originalEl.style.display = '';
      } else {
        originalEl.style.display = 'none';
      }
    }
    document.querySelectorAll('#addToCartPrice, #finalCtaPrice, #stickyPrice').forEach(function(el){
      el.textContent = fmtMoney(selPriceCents);
    });
    if(addToCartBtn) addToCartBtn.dataset.variantId = sel.dataset.variantId;
    if(finalCtaBtn) finalCtaBtn.dataset.variantId = sel.dataset.variantId;
    var stickyBtn = document.getElementById('stickyCartBtn');
    if(stickyBtn) stickyBtn.dataset.variantId = sel.dataset.variantId;
  }

  function selectBundle(row){
    bundleRows.forEach(function(r){ r.setAttribute('aria-checked', r === row ? 'true' : 'false'); });
    renderBundleUI();
  }
  bundleRows.forEach(function(row){
    row.addEventListener('click', function(){ selectBundle(row); });
  });
  renderBundleUI();

  var mainPhoto = document.getElementById('pdpMainPhoto');
  document.querySelectorAll('.gallery-thumb').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      document.querySelectorAll('.gallery-thumb').forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
      if(mainPhoto && thumb.dataset.full) mainPhoto.style.backgroundImage = 'url(' + thumb.dataset.full + ')';
    });
  });

  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('drawerOverlay');
  var drawerBody = document.getElementById('drawerBody');
  var drawerSubtotal = document.getElementById('drawerSubtotal');
  var cartCountEls = document.querySelectorAll('#cartCount');

  function updateBodyLock(){
    var anyOpen = drawer.classList.contains('show') || (spinModal && spinModal.classList.contains('show'));
    document.body.classList.toggle('modal-lock', anyOpen);
  }

  function renderCart(cart){
    cartCountEls.forEach(function(el){ el.textContent = cart.item_count; });
    if(!cart.items.length){
      drawerBody.innerHTML = '<p class="drawer-empty-msg">Your cart is empty.</p>';
      drawerSubtotal.textContent = fmtMoney(0);
      return;
    }
    var html = '';
    cart.items.forEach(function(item){
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_100x100$1$2') : '';
      html += '<div class="drawer-item">' +
        (img ? '<div class="drawer-item-icon" style="background-image:url(' + img + ')"></div>' : '<div class="drawer-item-icon"></div>') +
        '<div class="drawer-item-info">' +
          '<div class="drawer-item-name">' + item.product_title + (item.variant_title ? ' — ' + item.variant_title : '') + '</div>' +
          '<div class="drawer-item-meta">Qty ' + item.quantity + '</div>' +
          '<button type="button" class="drawer-item-remove" data-key="' + item.key + '">Remove</button>' +
        '</div>' +
        '<div class="drawer-item-price tabular">' + fmtMoney(item.final_line_price) + '</div>' +
      '</div>';
    });
    drawerBody.innerHTML = html;
    drawerSubtotal.textContent = fmtMoney(cart.total_price);

    drawerBody.querySelectorAll('.drawer-item-remove').forEach(function(btn){
      btn.addEventListener('click', function(){
        changeLine(btn.dataset.key, 0);
      });
    });
  }

  function fetchCart(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart);
  }

  function changeLine(key, quantity){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r){ return r.json(); }).then(renderCart);
  }

  function openDrawer(){
    drawer.classList.add('show');
    overlay.classList.add('show');
    updateBodyLock();
    fetchCart();
  }
  function closeDrawer(){
    drawer.classList.remove('show');
    overlay.classList.remove('show');
    updateBodyLock();
  }

  function addToCart(variantId, btn){
    if(!variantId) return;
    var originalText = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function(r){
        if(!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function(){
        cartCountEls.forEach(function(el){ el.classList.add('bump'); setTimeout(function(){ el.classList.remove('bump'); }, 220); });
        openDrawer();
      })
      .catch(function(){
        if(btn) btn.textContent = 'Something went wrong — try again';
      })
      .finally(function(){
        if(btn){ btn.disabled = false; btn.textContent = originalText; }
      });
  }

  document.querySelectorAll('#addToCartBtn, #finalCtaBtn, #stickyCartBtn').forEach(function(btn){
    btn.addEventListener('click', function(){ addToCart(btn.dataset.variantId, btn); });
  });
  document.getElementById('cartBtn').addEventListener('click', openDrawer);
  document.getElementById('drawerClose').addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ closeDrawer(); }
  });

  document.querySelectorAll('.faq-item').forEach(function(item){
    var btn = item.querySelector('.faq-q');
    var answer = item.querySelector('.faq-a');
    btn.addEventListener('click', function(){
      var open = item.dataset.open === 'true';
      item.dataset.open = open ? 'false' : 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      answer.style.maxHeight = open ? '0px' : answer.scrollHeight + 'px';
    });
  });
  document.querySelectorAll('.pdp-accordion').forEach(function(item){
    var btn = item.querySelector('.pdp-accordion-q');
    var answer = item.querySelector('.pdp-accordion-a');
    btn.addEventListener('click', function(){
      var open = item.dataset.open === 'true';
      item.dataset.open = open ? 'false' : 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      answer.style.maxHeight = open ? '0px' : answer.scrollHeight + 'px';
    });
  });

  var heroCta = addToCartBtn;
  var stickyCta = document.getElementById('stickyCta');
  if(heroCta && stickyCta && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ stickyCta.classList.remove('show'); }
        else if(e.boundingClientRect.top < 0){ stickyCta.classList.add('show'); }
        else { stickyCta.classList.remove('show'); }
      });
    }, { threshold: 0 });
    io.observe(heroCta);
  } else if(stickyCta){
    stickyCta.style.display = 'none';
  }

  document.querySelectorAll('.reveal').forEach(function(el){ el.classList.remove('in-view'); });
  document.querySelectorAll('.home-hero .reveal, .pdp-gallery, .pdp-info').forEach(function(el){ el.classList.add('in-view'); });
  if('IntersectionObserver' in window && !reduced){
    var revealIo = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in-view'); revealIo.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.reveal:not(.in-view)').forEach(function(el){ revealIo.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in-view'); });
  }

  var spinOverlay = document.getElementById('spinOverlay');
  var spinModal = document.getElementById('spinModal');
  if(spinOverlay && spinModal){
    var spinIntro = document.getElementById('spinIntro');
    var spinResult = document.getElementById('spinResult');
    var spinBtn = document.getElementById('spinBtn');
    var wheelSvg = document.getElementById('wheelSvg');
    var wheelFreeIndex = 0;
    var spinning = false;
    var won = false;

    function revealShipBadges(){
      document.querySelectorAll('.ship-badge').forEach(function(b){ b.classList.add('show'); });
    }

    window.openSpin = function(){
      if(won) return;
      spinOverlay.classList.add('show');
      spinModal.classList.add('show');
      updateBodyLock();
    };
    window.closeSpin = function(){
      spinOverlay.classList.remove('show');
      spinModal.classList.remove('show');
      updateBodyLock();
    };

    function finishSpin(){
      spinIntro.style.display = 'none';
      spinResult.style.display = 'flex';
      won = true;
      try{ sessionStorage.setItem('freeShipWon', 'true'); }catch(e){}
      revealShipBadges();
    }

    function doSpin(){
      if(spinning) return;
      spinning = true;
      spinBtn.disabled = true;
      spinBtn.textContent = 'Spinning…';
      var jitter = (Math.random() * 22 - 11);
      var target = wheelFreeIndex * 60 + 30 + jitter;

      if(reduced){
        wheelSvg.style.transition = 'none';
        wheelSvg.style.transform = 'rotate(' + ((360 - target) % 360) + 'deg)';
        setTimeout(finishSpin, 50);
        return;
      }

      var phase1 = 5 * 360 + 40;
      wheelSvg.style.transition = 'transform 1.6s cubic-bezier(.4,0,.9,.4)';
      wheelSvg.style.transform = 'rotate(' + phase1 + 'deg)';

      wheelSvg.addEventListener('transitionend', function onPhase1(e){
        if(e.propertyName !== 'transform') return;
        wheelSvg.removeEventListener('transitionend', onPhase1);
        var phase2 = 7 * 360 + ((360 - target) % 360);
        wheelSvg.style.transition = 'transform 3.6s cubic-bezier(.08,.75,.1,1)';
        wheelSvg.style.transform = 'rotate(' + phase2 + 'deg)';
        wheelSvg.addEventListener('transitionend', function onPhase2(e2){
          if(e2.propertyName !== 'transform') return;
          wheelSvg.removeEventListener('transitionend', onPhase2);
          finishSpin();
        });
      });
    }

    spinBtn.addEventListener('click', doSpin);
    document.getElementById('spinDone').addEventListener('click', window.closeSpin);
    document.getElementById('codeCopy').addEventListener('click', function(evt){
      var copyBtn = evt.currentTarget;
      if(navigator.clipboard){ navigator.clipboard.writeText('FREESHIP').catch(function(){}); }
      var original = copyBtn.textContent;
      copyBtn.textContent = 'Copied!';
      setTimeout(function(){ copyBtn.textContent = original; }, 1500);
    });

    try{
      won = sessionStorage.getItem('freeShipWon') === 'true';
    }catch(e){}
    if(won){
      revealShipBadges();
    } else {
      setTimeout(window.openSpin, 2000);
    }
  }

  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
    cartCountEls.forEach(function(el){ el.textContent = cart.item_count; });
  }).catch(function(){});
})();
